import { PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  title: makeThemeColor(PRIMARY),
};

export const PASSWORD_WIDTH = {
  [HD]: 436,
  [FULL_HD]: 491,
};

export const TEXT_PASSWORD_HEIGHT = {
  [HD]: 36,
  [FULL_HD]: 48,
};

export const TEXT_PASSWORD_MARGIN_BOTTOM = 24;

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  flex: { direction: 'column', alignItems: 'center' },
  TextPassword: {
    flexItem: { marginBottom: TEXT_PASSWORD_MARGIN_BOTTOM },
    h: TEXT_PASSWORD_HEIGHT[screenSize],
    visible: false,
    text: {
      ...getFont(FONT.KINSHASA_1, screenSize),
      maxLines: 1,
      maxLinesSuffix: '...',
      wordWrapWidth: PASSWORD_WIDTH[screenSize],
      textAlign: 'center',
      textColor: colors.title[colorMode],
      verticalAlign: 'middle',
    },
  },
});
